import { Tooltip } from '@/components/ui/custom/dataDisplay/Tooltip';
import { Project } from '@/models/Project';
import { ClassNameComponent } from '@/utils/ClassNameComponent';
import { EyeIcon, HeartIcon } from '@heroicons/react/24/outline';
import { HeartIcon as SolidHeartIcon } from '@heroicons/react/20/solid';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import Interaction from './Interaction';
import { useUpvoting } from './Interactions.hooks';

type InteractionContainerProps = {
  project: Project;
  className?: Pick<ClassNameComponent, 'base' | 'tag' | 'img'>;
  onMutate?: (project: Project) => void;
};

export default function Interactions({
  project,
  className,
  onMutate,
}: PropsWithChildren<InteractionContainerProps>) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'projects.card',
  });
  const { upVoted, upVotes, views } = project;

  const { upVote, isUpvoting } = useUpvoting(project, onMutate);

  const UpVotedIcon = upVoted ? SolidHeartIcon : HeartIcon;
  return (
    <div
      className={twMerge(
        'absolute right-3 top-3 flex items-center gap-1 text-base-content',
        className?.base,
      )}
      data-testid="interactionsCard"
    >
      <Tooltip text={t('views')}>
        <Interaction
          count={views}
          color="primary"
          className={className}
          icon={EyeIcon}
        />
      </Tooltip>

      <Tooltip text={t('likes')}>
        <Interaction
          count={upVotes}
          icon={UpVotedIcon}
          className={className}
          color="error"
          isLoading={isUpvoting}
          onClick={upVote}
          testId="upvoteButton"
          whileHover={{
            scale: 1.1,
          }}
        />
      </Tooltip>
    </div>
  );
}
